import { render, staticRenderFns } from "./orderKuaizhao.vue?vue&type=template&id=0440fe2e&scoped=true&"
import script from "./orderKuaizhao.vue?vue&type=script&lang=js&"
export * from "./orderKuaizhao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0440fe2e",
  null
  
)

export default component.exports